import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DrawersActions } from 'app/cross-cutting-concerns/drawers/state/drawersSlice';

/**
 * Opens/closes the machine details drawer from `/:id` (and `/:id/:tab`) route params.
 */
export const useOpenMachineDetailsDrawerFromUrl = (): void => {
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(DrawersActions.showMachineDetailsDrawer({ machineId: id }));
      return;
    }
    dispatch(DrawersActions.hideMachineDetailsDrawer());
  }, [dispatch, id]);
};
